import { useMutation } from '@apollo/client';
import { useNavigate } from 'react-router-dom';

import {
    type CaptureConsentsConfig,
    type ConsentInput,
    type GroupedConsent,
    CaptureConsents as LibraryCaptureConsents,
} from '@phx/consents/client';

import {
    ConsentStatus,
    GetPendingConsentsDocument,
    UpdateConsentsDocument,
    type UpdateConsentsMutation,
    type UpdateConsentsMutationVariables,
} from '../../graphql/generated/graphql';
import { getAbsoluteRoute } from '../../util/get-absolute-route';

import { ConsentInfoScreen } from './ConsentInfoScreen';

type CaptureConsentsProps = {
    groupedConsents: GroupedConsent[];
};

export const CaptureConsents = ({ groupedConsents }: CaptureConsentsProps) => {
    const navigate = useNavigate();

    const [updateConsents] = useMutation<
        UpdateConsentsMutation,
        UpdateConsentsMutationVariables
    >(UpdateConsentsDocument, {
        refetchQueries: [{ query: GetPendingConsentsDocument }],
        awaitRefetchQueries: true,
    });

    const handleUpdateConsents = async (input: ConsentInput[]) => {
        const updateInput = input.map((consent) => ({
            consentHash: consent.consentHash,
            consentVersionId: consent.consentVersionId,
            status: consent.status as ConsentStatus,
            consentType: consent.consentType,
        }));

        await updateConsents({ variables: { input: updateInput } });
    };

    const config: CaptureConsentsConfig = {
        onUpdateConsents: handleUpdateConsents,
        onError: () => navigate(getAbsoluteRoute('error')),
        InfoScreen: ConsentInfoScreen,
    };

    return (
        <LibraryCaptureConsents
            groupedConsents={groupedConsents}
            config={config}
        />
    );
};
